// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cn from 'classnames/bind';
// Hooks
import { useDispatch } from 'react-redux';
// Utils
import { isMobileV2 } from 'src/utils/ui';
import BADGE_TYPE from './constants';
import { getStatusInfo } from 'src/utils/status';
import { push, evPortalPath } from 'src/utils/paths';
import { getBadgeStatusConfig } from 'src/containers/Account/OrdersPage/utils';
// Components & Styles
import { PanelV2 } from 'src/components/HTKit/Elements/PanelV2';
import { Badge } from 'src/components/Elements/Badge';
import styles from './styles.scss';

const WorkflowStatusHeader = ({ order, badgeType, label }) => {
  const isMobile = isMobileV2();
  const { createdAt, appointmentsRequired } = order.workflow;
  const formattedCreatedAtDate = new Date(createdAt).toLocaleDateString('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const { statusBadgeType, statusLabel } = getBadgeStatusConfig(order, badgeType, label);
  const serviceName = order.breakdown.services[0].name; // For workflows we are only showing one service
  return (
    <div className="flex justifyContentSpaceBetween">
      <div>
        <h5 className="marginBottom-tiny1">{serviceName}</h5>
        <p
          className={cn(
            styles.workflowAppointmentsRequired,
            'padding-tiny1 marginBottom-tiny1 caption',
          )}
        >
          {appointmentsRequired} Appointments required
        </p>
        <Badge
          size={isMobile ? 'small' : 'large'}
          type={statusBadgeType.type}
          variant={statusBadgeType.variant}
        >
          {statusLabel}
        </Badge>
      </div>
      <p className="p2 n700">Created {formattedCreatedAtDate}</p>
    </div>
  );
};
export const WorkflowCard = ({ order }) => {
  const dispatch = useDispatch();
  const { label, panel } = getStatusInfo({ order });
  const badgeType = get(BADGE_TYPE, `${panel}['badge']`, {});

  const { token } = order.workflow;

  return (
    <PanelV2 lightShadow className={styles.panel}>
      <div
        role="button"
        aria-pressed="false"
        onClick={() => dispatch(push(evPortalPath(token)))}
        className={styles.cardTitleWrapper}
      >
        <WorkflowStatusHeader order={order} badgeType={badgeType} label={label} />
      </div>
    </PanelV2>
  );
};

const orderPropType = {
  id: PropTypes.number,
  workflow: PropTypes.shape({
    createdAt: PropTypes.string,
    appointmentsRequired: PropTypes.number,
    appointmentsCompleted: PropTypes.number,
  }),
  breakdown: PropTypes.shape({
    services: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ),
  }),
};

WorkflowStatusHeader.propTypes = {
  order: PropTypes.shape(orderPropType).isRequired,
  badgeType: PropTypes.shape({
    type: PropTypes.string,
    variant: PropTypes.string,
  }),
  label: PropTypes.string,
};

WorkflowCard.propTypes = {
  order: PropTypes.shape(orderPropType).isRequired,
};
